var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"homeFooter"},[_c('div',{staticClass:"footer-container"},[_c('ul',[_c('li',[_vm._v("版权©️海南会多多信息技术有限公司")]),_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://beian.miit.gov.cn/#/Integrated/recordQuery"}},[_vm._v("琼ICP备2021004082号-1")])])])])])
}]

export { render, staticRenderFns }